import { CheckCircle } from "@mui/icons-material";
import { Card, CardContent, CardMedia, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { demoChannelTitle, demoChannelUrl, demoVideoTitle, demoVideoUrl } from "../../utils/Constants";


const VideoCard = ({ video: { id: { videoId }, snippet } }) => {
    // console.log(videoId, snippet);
    return (
        <div>
            <Card sx={{width:{sx:"100%",md:"320px"}}}>
                <Link to={videoId ? `/videos/${videoId}` : demoVideoUrl}>
                    <CardMedia alt={snippet?.title} sx={{ width: "358px", height: "180px" }} image={snippet?.thumbnails?.medium?.url} />
                    <CardContent sx={{ backgroundColor: "#1e1e1e", height: "106px" }}>
                        <Typography variant="subtitle1" fontWeight={"bold"} sx={{ color: "#fff" }}>
                            {snippet?.title.slice(0, 30) || demoVideoTitle.slice(0, 30)}...
                        </Typography>

                        <Link to={snippet?.channelId ? `/channel/${snippet.channelId}` : demoChannelUrl}>

                            <Typography variant="subtitle2" color="gray" fontWeight={"bold"} className="flex justify-start items-center">
                                {snippet?.channelTitle.slice(0, 60) || demoChannelTitle.slice(0, 60)}
                                <CheckCircle sx={{fontSize:12,ml:1}}/>
                            </Typography>
                        </Link>
                    </CardContent>

                </Link>
            </Card>
        </div>
    )
}

export default VideoCard
